import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListSubscribers from '../../components/subscribers/list-subscribers.component';
import PAGE_TITLE_LIST from '../../config/page-title.config';

const SubscribersView = () => {
  const pageTitle = PAGE_TITLE_LIST.SUBSCRIBERS;

  return (
    <AppLayout pageTitle={pageTitle}>
      <ListSubscribers />
    </AppLayout>
  );
};

export default SubscribersView;
